import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import { Dropdown, Form, FormField, FormGroup, Input, Label } from "semantic-ui-react";

import UserProfileImage from "react-lib/apps/IsHealth/REG/UserProfileImage";

type InformationDetailedProps = {
  detail?: InformationDetailedDataType;
  error?: Record<string, any>;
  readOnly?: boolean;
  healthFacilityTypeOptions?: Record<string, any>[];
};

export type InformationDetailedDataType = Partial<{
  accountName: string;
  address: string;
  description: string;
  fileImage?: File | null;
  hospital_name: string;
  image?: string | null;
  username: string;
}>;

const HOSPITAL_IMAGE_URL = `${process.env.PUBLIC_URL}/static/images/hospital.png`;

const InformationFormDetailed = forwardRef<any, InformationDetailedProps>((props, ref) => {
  const [detail, setDetail] = useState<InformationDetailedDataType>({});

  useImperativeHandle(ref, () => ({
    getData: (): InformationDetailedDataType => ({
      accountName: detail.accountName,
      address: detail.address,
      description: detail.description,
      fileImage: detail.fileImage,
      hospital_name: detail.hospital_name,
      image: detail.image,
    }),
  }));

  useEffect(() => {
    if (props.detail) {
      setDetail(props.detail);
    }
  }, [props.detail]);

  const handleInputChange = (e: any, data: any) => {
    setDetail((prev) => ({
      ...prev,
      [data.name]: data.value,
    }));
  };

  const handleImageChange = (file: File, fileUrl: string) => {
    setDetail((prev) => ({
      ...prev,
      fileImage: file,
      image: fileUrl,
    }));
  };

  const handleClearImage = () => {
    setDetail((prev) => ({
      ...prev,
      fileImage: null,
      image: props.detail?.image,
    }));
  };

  return (
    <div className="information-form-detailed">
      <div>
        <div style={{ marginBottom: "1rem" }}>
          <Label style={{ backgroundColor: "var(--light-bg-color)", width: "100%" }} size="large">
            ข้อมูลเข้าสู่ระบบ
          </Label>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          <Label style={{ backgroundColor: "var(--light-bg-color)", width: "100%" }} size="large">
            ข้อมูลบัญชี
          </Label>
        </div>
        <UserProfileImage
          src={detail.image || HOSPITAL_IMAGE_URL}
          onChange={handleImageChange}
          onClear={handleClearImage}
        />
      </div>
      <div>
        <div>
          <Label style={{ minWidth: "20rem" }} size="large">
            {props.detail?.username || "\u00A0"}
          </Label>
        </div>
        <Form className="--override-disabled --grey" style={{ marginTop: "5rem" }}>
          <FormGroup inline>
            <FormField style={{ alignItems: "baseline" }} width={11} inline required>
              <label>ชื่อ Official Account</label>

              <div style={{ width: "100%" }}>
                <Input
                  error={props.error?.accountName}
                  name="accountName"
                  placeholder="กรุณาระบุชื่อ"
                  readOnly={props.readOnly}
                  value={detail.accountName}
                  fluid
                  onChange={handleInputChange}
                />
                {props.error?.accountName && (
                  <label className="font-error" style={{ color: "red", fontSize: "12px" }}>
                    กรุณาระบุชื่อ Official Account
                  </label>
                )}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup inline>
            <FormField style={{ alignItems: "baseline" }} width={11} inline required>
              <label>ประเภทสถานพยาบาล</label>
              <div style={{ width: "100%" }}>
                <Dropdown
                  style={{ width: "100%" }}
                  disabled={props.readOnly}
                  error={props.error?.hospital_name}
                  name="hospital_name"
                  placeholder="-- กรุณาเลือกประเภทสถานพยาบาล --"
                  value={detail.hospital_name}
                  fluid
                  search
                  selection
                  options={props.healthFacilityTypeOptions}
                  onChange={handleInputChange}
                />
                {props.error?.hospital_name && (
                  <label className="font-error" style={{ color: "red", fontSize: "12px" }}>
                    กรุณาเลือกประเภทสถานพยาบาล
                  </label>
                )}
              </div>
            </FormField>
          </FormGroup>
          <FormGroup inline>
            <FormField width={11} inline>
              <label>ตำแหน่งสถานที่ตั้ง</label>
              <Input
                name="address"
                placeholder="กรุณาระบุสถานที่ตั้ง"
                readOnly={props.readOnly}
                value={detail.address}
                onChange={handleInputChange}
              />
            </FormField>
          </FormGroup>
          <FormGroup inline>
            <FormField width={11} inline>
              <label>รายละเอียดเพิ่มเติม</label>
              <Input
                name="description"
                placeholder="กรุณาระบุรายละเอียด"
                readOnly={props.readOnly}
                value={detail.description}
                fluid
                onChange={handleInputChange}
              />
            </FormField>
          </FormGroup>
        </Form>
      </div>
    </div>
  );
});

InformationFormDetailed.displayName = "InformationFormDetailed";

export default React.memo(InformationFormDetailed);
